<template>
<div>
  <h3 class="is-size-3">{{ finding.findable.type.title }}</h3>

  <component :vulnerability="finding.vulnerable" :is="`${finding.vulnerable_type}-vulnerability`"/>
</div>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  
  computed: {
    ...mapGetters('finding', [
      'finding'
    ])
  }

}
</script>